import { render, staticRenderFns } from "./BlockLog.vue?vue&type=template&id=07e5de41&scoped=true"
import script from "./BlockLog.vue?vue&type=script&lang=js"
export * from "./BlockLog.vue?vue&type=script&lang=js"
import style0 from "./BlockLog.vue?vue&type=style&index=0&id=07e5de41&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e5de41",
  null
  
)

export default component.exports